import type {
  TLastActivityCourseItemType,
  TLastActivityItem,
} from '@crehana/compass.dashlets/last-activity-widget';
import { toast } from '@crehana/compass.ui/toaster';
import { useTranslation } from '@crehana/i18n';
import { date } from '@crehana/utils';

import { ActivityTypeEnum } from '@/generated/graphql/types';

import { useGetLastActivityByUserQueryQuery } from './graphql/get-last-activity-by-user.v5.generated';

const ERROR_TYPES = [
  'FoundationHomeUserValidationError',
  'FoundationHomeUserInternalError',
  'FoundationHomeUserIntegrityError',
];

export const useLastActivityQuery = () => {
  const { t } = useTranslation();

  const {
    data,
    loading,
    error: errorQuery,
    refetch,
  } = useGetLastActivityByUserQueryQuery({
    notifyOnNetworkStatusChange: true,
    context: { clientName: 'v5' },
    onError: () => toast.error(t('ERROR_FETCHING_LAST_ACTIVITY')),
  });

  const error =
    ERROR_TYPES.includes(
      data?.foundation_home_user?.get_last_activity_by_user?.__typename ?? '',
    ) || !!errorQuery;

  const node =
    data?.foundation_home_user?.get_last_activity_by_user?.__typename ===
    'GetLastActivityByUserInfo'
      ? data?.foundation_home_user?.get_last_activity_by_user
      : undefined;

  const lastActivity = node
    ? ({
        courseId: Number(node.course_id),
        courseName: node.course_name ?? '',
        isRequired: node.is_required ?? false,
        imageUrl: node.image_url ?? '',
        courseType: node.course_type as unknown as TLastActivityCourseItemType,
        remainingTime: node.remaining_time
          ? date.toMinutes(node.remaining_time)
          : '',
        progress:
          node.activity_type === ActivityTypeEnum.LastPlayType && node.duration
            ? ((node.progress_seconds ?? 0) / node.duration) * 100
            : 0,
        activityType: node.activity_type,
        playerUrl: node.player_url ?? '',
      } as TLastActivityItem)
    : undefined;

  return {
    loading,
    error,
    refetch,
    lastActivity,
  };
};
